// import React from "react";
// import { BrowserRouter as Router, Route } from "react-router-dom";

// import routes from "./routes";
// import withTracker from "./withTracker";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "./assets/main.scss";

// export default () => (
//   <Router basename={process.env.REACT_APP_BASENAME || ""}>
//     <div>
//       {routes.map((route, index) => {
//         return (
//           <Route
//             key={index}
//             path={route.path}
//             exact={route.exact}
//             component={withTracker(props => {
//               return (
//                 <route.layout {...props}>
//                   <route.component {...props} />
//                 </route.layout>
//               );
//             })}
//           />
//         );
//       })}
//     </div>
//   </Router>
// );



// import React from "react";
// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import routes from "./routes"; // Import routes

// import withTracker from "./withTracker"; // If you're using this HOC

// import "bootstrap/dist/css/bootstrap.min.css";
// import "./assets/main.scss";

// export default () => (
//   <Router basename={process.env.REACT_APP_BASENAME || ""}>
//     <Switch>
//       {routes.map((route, index) => (
//         <Route
//           key={index}
//           path={route.path}
//           exact={route.exact || false} // default to false if `exact` isn't specified
//           render={(props) => {
//             // Apply your withTracker HOC here
//             const Component = route.component;
//             const Layout = route.layout || React.Fragment; // Fallback to a simple wrapper if no layout

//             return (
//               <Layout {...props}>
//                 <withTracker>
//                   <Component {...props} />
//                 </withTracker>
//               </Layout>
//             );
//           }}
//         />
//       ))}
//     </Switch>
//   </Router>
// );
// App.js


// App.js


import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import routes from "./routes";
import withTracker from "./withTracker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/main.scss";

// ProtectedRoute Component
const ProtectedRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn);

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Layout {...props}>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

const App = () => {
  return (
    <Router basename={process.env.REACT_APP_BASENAME || ""}>
      <Switch>
        {routes.map((route, index) => {
          const { component: Component, layout: Layout, path, exact, protected: isProtected } = route;
          const RouteComponent = isProtected ? ProtectedRoute : Route;

          return (
            <RouteComponent
              key={index}
              path={path}
              exact={exact || false}
              component={withTracker(Component)}
              layout={Layout || React.Fragment}
            />
          );
        })}
      </Switch>
    </Router>
  );
};

export default App;
